import { gray40opacity10 } from '../../../colors/gray';
import { red03 } from '../../../colors/red';
import { shape } from '../shape';
export var MuiLinearProgress = {
    styleOverrides: {
        root: {
            borderRadius: shape === null || shape === void 0 ? void 0 : shape.borderRadius,
            height: 12,
        },
        colorPrimary: {
            backgroundColor: gray40opacity10,
        },
        barColorPrimary: {},
        colorSecondary: {
            backgroundColor: gray40opacity10,
        },
        barColorSecondary: {
            backgroundColor: red03,
        },
    },
    customOverrides: {
        sizeSmall: {
            height: 8,
        },
    },
};
